import axios from "axios";
import React, { useEffect, useState } from "react";
import Layout from "../../components/Layout/Page";
import ProjectsHeader from "./Header/index";
import { LoadingContainer } from "./styled.components";
import Tab from "./Tab/index";
import { BACKEND_URL } from "../../constants/urls";
const EventsAndSeminar = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const getData = async () => {
    setIsLoading(true);
    const response = await axios.get(`${BACKEND_URL}/events`);
    setData(response.data);
    setIsLoading(false);
  };

  useEffect(() => {
    getData();
  }, []);
  useEffect(() => {
    console.log(data);
  }, [data]);

  return (
    <Layout>
      <ProjectsHeader />
      {data && <Tab data={data} />}
    </Layout>
  );
};

export default EventsAndSeminar;
